var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    status: statuses.IDLE,
    name: 'Sans nom',
};
export default function CampaignReducer(state, actions) {
    if (state === void 0) { state = initialState; }
    var type = actions.type, payload = actions.payload;
    switch (type) {
        case types.FETCH_CAMPAIGN_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING });
        case types.FETCH_CAMPAIGN_SUCCESS:
            return __assign(__assign(__assign({}, state), { status: statuses.SUCCESS }), payload);
        case types.FETCH_CAMPAIGN_ERROR:
            return __assign(__assign({}, state), { status: statuses.FAIL });
        case types.UPDATE_DOCUMENT_REQUEST:
            return __assign(__assign({}, state), { documentRequest: statuses.LOADING });
        case types.UPDATE_DOCUMENT_SUCCESS:
            if (payload && 'type' in payload && 'id' in payload) {
                return __assign(__assign({}, state), { documentRequest: statuses.SUCCESS });
            }
            return state;
        case types.UPDATE_DOCUMENT_ERROR:
            return __assign(__assign({}, state), { documentRequest: statuses.FAIL });
        case types.LAUNCH_CAMPAIGN:
            return __assign(__assign({}, state), { type: 'campaign' });
        default:
            return state;
    }
}
